import { Pipe, PipeTransform } from "@angular/core";
import * as moment from "moment";
import { TimeService } from "@app2/shared/services/time.service";
import { ShortDatePipe } from "@app2/shared/pipes/short-date.pipe";
import { Duration } from "moment";

@Pipe({ name: "intervalShortDate" })
export class IntervalShortDatePipe implements PipeTransform {
    constructor(private timeService: TimeService) {
    }

    transform(isoDate: string, shortDifference = false) {
        return IntervalShortDatePipe.transformImpl(isoDate, shortDifference, this.timeService);
    }

    public static transformImpl(isoDate: string, shortDifference: boolean, timeSource: any) {
        const now = timeSource.now();
        const momentDate = timeSource.timeZoneMoment(isoDate);

        if (!momentDate.isValid()) return isoDate;

        const formattedDate = ShortDatePipe.transformImpl(isoDate, timeSource);
        const diffWithNow = moment.duration(now.diff(momentDate), "milliseconds");
        return `${formattedDate} (${shortDifference
            ? IntervalShortDatePipe.shortHumanize(diffWithNow)
            : diffWithNow.humanize()})`;
    }

    // array because object iteration order is arbitrary, also backwards order to find first entry that is less than the duration
    private static timeIntervals: [string, number][] = [
        ["w", 60 * 60 * 24 * 7],
        ["d", 60 * 60 * 24],
        ["h", 60 * 60],
    ];

    private static shortHumanize(duration: Duration) {
        const seconds = duration.asSeconds();
        const [unit, interval] = IntervalShortDatePipe.timeIntervals
            .find(([, interval]) => interval < seconds)
            ?? IntervalShortDatePipe.timeIntervals[IntervalShortDatePipe.timeIntervals.length - 1];
        return Math.floor(seconds / interval) + unit;
    }
}
